import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { MAX_CHARITY_NAME_LENGTH, MAX_GRANT_AMOUNT_LENGTH, MAX_PRESS_RELEASE_TEXT_AREA_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { formatNumberWithCommasTransform } from '@module/mdrt-org/shared/utils/helpers/allow-only-numbers';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { FormTextarea } from '@shared/ui-components/form-textarea/form-textarea';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type DonationSectionProps = {
  cmsContent: {
    charityNameInputLabel: string;
    donationReasonInputLabel: string;
    donationSectionTitle: string;
    grantAmountInputLabel: string;
    requiredLabel: string;
  };
  containerClass: string;
  setActiveField: (field: string) => void;
};
export const DonationSection = t0 => {
  const $ = _c(35);
  const {
    cmsContent,
    containerClass,
    setActiveField
  } = t0;
  const t1 = styles[`${containerClass}__donation-block`];
  let t2;
  if ($[0] !== cmsContent.donationSectionTitle) {
    t2 = <h2 className={styles["section-title"]}>{cmsContent.donationSectionTitle}</h2>;
    $[0] = cmsContent.donationSectionTitle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = styles[`${containerClass}__donation-block-inputs`];
  let t4;
  if ($[2] !== cmsContent.requiredLabel) {
    t4 = {
      required: cmsContent.requiredLabel
    };
    $[2] = cmsContent.requiredLabel;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== setActiveField) {
    t5 = <FormInput onFocus={() => setActiveField("CharityName")} />;
    $[4] = setActiveField;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cmsContent.charityNameInputLabel || $[7] !== t4 || $[8] !== t5) {
    t6 = <FieldController label={cmsContent.charityNameInputLabel} maxLength={MAX_CHARITY_NAME_LENGTH} name="charityName" rules={t4}>{t5}</FieldController>;
    $[6] = cmsContent.charityNameInputLabel;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== cmsContent.requiredLabel) {
    t7 = {
      required: cmsContent.requiredLabel
    };
    $[10] = cmsContent.requiredLabel;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== setActiveField) {
    t8 = <FormInput onFocus={() => setActiveField("GrantAmount")} />;
    $[12] = setActiveField;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== cmsContent.grantAmountInputLabel || $[15] !== t7 || $[16] !== t8) {
    t9 = <FieldController label={cmsContent.grantAmountInputLabel} maxLength={MAX_GRANT_AMOUNT_LENGTH} name="grantAmount" rules={t7} transform={formatNumberWithCommasTransform}>{t8}</FieldController>;
    $[14] = cmsContent.grantAmountInputLabel;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t6 || $[20] !== t9) {
    t10 = <div className={t3}>{t6}{t9}</div>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== cmsContent.requiredLabel) {
    t11 = {
      required: cmsContent.requiredLabel
    };
    $[22] = cmsContent.requiredLabel;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== setActiveField) {
    t12 = <FormTextarea onFocus={() => setActiveField("DonationReason")} />;
    $[24] = setActiveField;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== cmsContent.donationReasonInputLabel || $[27] !== t11 || $[28] !== t12) {
    t13 = <FieldController displayMaxLengthCounter={true} label={cmsContent.donationReasonInputLabel} maxLength={MAX_PRESS_RELEASE_TEXT_AREA_LENGTH} name="donationInformation" rules={t11}>{t12}</FieldController>;
    $[26] = cmsContent.donationReasonInputLabel;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t1 || $[31] !== t10 || $[32] !== t13 || $[33] !== t2) {
    t14 = <section className={t1}>{t2}{t10}{t13}</section>;
    $[30] = t1;
    $[31] = t10;
    $[32] = t13;
    $[33] = t2;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};